import {
  Directive,
  TemplateRef,
  OnChanges,
  SimpleChanges,
  Input,
} from '@angular/core';

@Directive({
  selector: '[appRecarga]',
})
export class RecargaDirective {
  @Input() Recargar!: number;

  constructor() {}
}
